__turbopack_context__.v({
  "footerSurface": "QuickSearchNlpUpsellFooter-module__cOCdZa__footerSurface",
  "footerWrapper": "QuickSearchNlpUpsellFooter-module__cOCdZa__footerWrapper",
});
